const ldk4Tab = (() => {
  const page4ldk = (document.getElementById("page4ldk") != null);
  if (page4ldk) {



    let secPoint3 = document.querySelector("#jsSecPoint3")
    let tabBtns = secPoint3.querySelectorAll(".js-tab-btn")
    let tabCntnts = secPoint3.querySelectorAll(".js-tab-cntnt")


    tabBtns[0].classList.add('act');
    tabCntnts[0].classList.add('act');

    tabBtns.forEach((element, index) => {

      element.addEventListener('click', () => {
        for (let i = 0; i < tabBtns.length; i++) {
          tabBtns[i].classList.remove('act');
          tabCntnts[i].classList.remove('act');
        }
        tabBtns[index].classList.add('act');
        tabCntnts[index].classList.add('act');
      });

    });



  }
})()
export default ldk4Tab;